export function createEventBus() {
    const subscribers = new Set();
    return {
        subscribe(cb) {
            subscribers.add(cb);
            return () => subscribers.delete(cb);
        },
        emit(event) {
            for (const cb of subscribers) {
                try { cb(event); } catch (e) { /* isolate */ }
            }
        },
    };
}
